<div class="image-container">
    <img [src]="data.imageSource">
</div>